import { useState, useRef } from 'react'
import Menu from '@mui/joy/Menu'
import MenuButton from '@mui/joy/MenuButton'
import MenuItem from '@mui/joy/MenuItem'
import Dropdown from '@mui/joy/Dropdown'

export const MenuDropdown = ({ label, children }) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleOpenChange = (e) => {
        // We've generally lost focus, close...
        if (e.type !== 'click') {
            setIsOpen(false)
            return
        }

        if (isOpen) {
            // user is still in the dropdown making changes, ignore the event.
            return
        }

        setIsOpen(true)
    }

    return (
        <Dropdown open={isOpen} onOpenChange={handleOpenChange}>
            <MenuButton sx={{ maxHeight: 40 }}>{label}</MenuButton>
            <Menu>
                <MenuItem>{children}</MenuItem>
            </Menu>
        </Dropdown>
    )
}
